module.exports = __webpack_public_path__ + "media/src/img/payment/down-arrow-1ac2b6defee08d0e5c7e593193c6e10f.svg";